import type { ComponentProps, ReactNode } from 'react'
import { Button } from '../ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip'

export type IconButtonProps = Omit<ComponentProps<typeof Button>, 'aria-label' | 'children'> & {
  label: string
  side?: ComponentProps<typeof TooltipContent>['side']
  children: ReactNode
}

export function IconButton({
  label,
  side = 'bottom',
  size = 'icon-sm',
  variant = 'ghost',
  type = 'button',
  children,
  ...button
}: IconButtonProps) {
  return (
    <Tooltip>
      <TooltipTrigger
        render={<Button {...button} type={type} variant={variant} size={size} aria-label={label} />}
      >
        {children}
      </TooltipTrigger>
      <TooltipContent side={side}>{label}</TooltipContent>
    </Tooltip>
  )
}
